import React from 'react';

import { useSelector } from 'react-redux';

import Spinner from '@/components/UI/Spinner';
import PasswordChange from '@/components/Pages/Settings/password-change/PasswordChange';
import Settings2FA from '../Settings2FA';
import UserDetails from '@/pages/settings/details/UserDetails';
import SmsEmailMarketing from '@/pages/settings/details/SmsEmailMarketing';
import BiometricSettings from '@/pages/settings/details/BiometricSettings';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectAutoLoginFinished } from '@/store/selectors/autoLoginSelectors';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { selectUser } from '@/store/selectors/userSelectors';
import { isRegulatedLocale } from '@/shared/utility';
import { envIsCanada } from '@/constants/constants';

const Details = () => {
  const locale = useSelector(selectLocale);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const autoLoginFinished = useSelector(selectAutoLoginFinished);
  const user = useSelector(selectUser);

  if (!isAuthenticated || !autoLoginFinished || !user) {
    return (
      <div className="min-h-[100vh-300px] bg-offWhite py-12 px-4 max-w-[720px] mx-auto sm:py-16 sm:px-8">
        <Spinner absolute />
      </div>
    );
  }

  return (
    <div className="min-h-[100vh-300px] bg-offWhite py-12 px-4 max-w-[720px] mx-auto sm:py-16 sm:px-8">
      {!isRegulatedLocale(locale) && <PasswordChange />}
      <UserDetails user={user} />
      <SmsEmailMarketing />
      <BiometricSettings />
      {(envIsCanada() || locale === 'th') && <Settings2FA />}
    </div>
  );
};

export default Details;
